<div class="list-search">
  <form>
    <mat-form-field>
      <input
        #searchInput
        matInput
        [placeholder]="TranslationKeys.FilterTypeSearch | translate"
        (blur)="searchInput.focus()"
        [formControl]="searchControl"
        spellcheck="false"
        autocomplete="off"
      />
      @if (searchControl?.value?.length) {
        <i matSuffix (click)="onRemoveSearch()" [nimbusIcon]="ICONS.CLOSE_LIGHT"></i>
      }
    </mat-form-field>
  </form>
</div>

@if (options$ | async; as availableOptions) {
  <div class="list">
    @if (selection?.length || availableOptions?.length) {
      <button nimbusPrimaryNoBorderButton class="nimbus-filter-control-button" (click)="toggleSelection()">
        <nimbus-input-check-box [checked]="hasSelection"></nimbus-input-check-box>
        <span class="selection-control-name">{{
          (hasSelection ? TranslationKeys.FilterClearSelection : TranslationKeys.FilterSelectAll) | translate
        }}</span>
      </button>
    }
    @if (selection?.length) {
      <div class="selection-list">
        @if (selection?.length !== flattenedData?.length) {
          @for (selectedOption of selection; track trackByFn($index, selectedOption)) {
            <nimbus-filter-hierarchy-select-list-item
              [selected]="selectedOptionsLookup[selectedOption.id]"
              (filterSelect)="onFilterSelect($event, true)"
              [withIndent]="false"
              [option]="selectedOption"
            ></nimbus-filter-hierarchy-select-list-item>
          }
          <hr />
        }
      </div>
    }
    <div class="available-list">
      @if (!availableOptions?.length) {
        <span class="no-records-filter">{{ TranslationKeys.GeneralGridNoRecords | translate }}</span>
      }
      @for (option of availableOptions; track trackByFn($index, option)) {
        <nimbus-filter-hierarchy-select-list-item
          [selected]="selectedOptionsLookup[option.id]"
          (filterSelect)="onFilterSelect($event)"
          [withIndent]="true"
          [option]="option"
        ></nimbus-filter-hierarchy-select-list-item>
      }
    </div>
  </div>
}
